import { render, staticRenderFns } from "./ClaimQuery.vue?vue&type=template&id=d879bda6&scoped=true"
import script from "./ClaimQuery.vue?vue&type=script&lang=js"
export * from "./ClaimQuery.vue?vue&type=script&lang=js"
import style0 from "./ClaimQuery.vue?vue&type=style&index=0&id=d879bda6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d879bda6",
  null
  
)

export default component.exports